module.exports = __webpack_public_path__ + "static/img/bearblitz.540bb93b.png";